import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

import { getListCreationProgress } from '../../data/service'

export const useProgress = (listId: string, isProgressModalOpen: boolean) => {
  const creatorId = useUnit($creatorId)

  const { data } = useQuery(
    ['listCreationProgress', listId],
    () => {
      return getListCreationProgress(creatorId!, listId)
    },
    {
      enabled: !!creatorId && !!listId && isProgressModalOpen,
      refetchInterval: (data) => !data?.completed && 2000,
      onError: (error) =>
        handleError(error, 'Failed to get list creation progress'),
    },
  )

  let progress = 0

  if (data) {
    progress = data.completed
      ? 100
      : data.total
        ? Math.round(((data.total - data.remaining) * 100) / data.total)
        : 0
  }

  return {
    progress,
    completed: data?.completed ?? false,
    success: data?.success,
    failure: data?.failure,
    total: data?.total,
  }
}
